// extracted by mini-css-extract-plugin
export default {"pd":"DataSet_pd__4aeZ7"};